<template>
  <div>
    <v-dialog
      hide-overlay
      v-model="task_list_modal"
      persistent
      max-width="1300px"
      min-height="500px !important"
      internal-activator
      style="overflow-y: hidden !important;overflow-x: hidden !important;overflow:hidden !important;"
    >
      <v-card tile :loading="task_list_loading">
        <v-card-title class="pa-0">
          <v-row dense no-gutters>
            <v-col class>
              <v-card-title class="pa-0">
                <v-col cols="4" class="d-flex pa-0">
                  <v-btn icon @click="task_list_modal=false;" to="/calendar" style="margin:10px;">
                    <v-icon size="25">mdi-calendar-check</v-icon>
                  </v-btn>
                  <v-col cols="11" class="text-center">
                    <span>{{ project_name }}</span>
                  </v-col>
                </v-col>
                <v-col cols="2" class="padding-5">Task Details</v-col>
                <v-col cols="6" class="padding-5">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-5 header_btn"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="addCalendarTaskModal()"
                        :disabled="selectedRows2.length > 0"
                      >
                        <v-icon size="28px">mdi-file-plus-outline</v-icon>
                        <span class="lable_class">Add</span>
                      </v-btn>
                    </template>
                    <span>Add</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-7 header_btn"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="scheduleTaskPopup(selectedRows2[0],2,'add')"
                        :disabled="selectedRows2.length == 0 || selectedRows2.length > 1 "
                      >
                        <v-icon size="28px">mdi-timetable</v-icon>
                        <span class="lable_class">Schedule</span>
                      </v-btn>
                    </template>
                    <span>Schedule Task(s)</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-7 header_btn"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="scheduleTaskPopup(selectedRows2[0],3, 'add')"
                        :disabled="selectedRows2.length == 0 || selectedRows2.length > 1  || selectedRows2[0]['schedule_count'] == 0"
                      >
                        <v-icon size="28px">mdi-timetable</v-icon>
                        <span class="lable_class">Reschedule</span>
                      </v-btn>
                    </template>
                    <span>ReSchedule Task(s)</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-7 header_btn"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="openDelayTaskPopup(selectedRows2[0], 'add')"
                        :disabled="selectedRows2.length == 0 || selectedRows2.length > 1 "
                      >
                        <v-icon size="28px">mdi-timer</v-icon>
                        <span class="lable_class">Delay</span>
                      </v-btn>
                    </template>
                    <span>Delay</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-7 header_btn"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="completeTaskPopup(selectedRows2[0])"
                        :disabled="selectedRows2.length == 0 || selectedRows2.length > 1  || (selectedRows2[0]['schedule_count'] == 0 && selectedRows2[0]['reschedule_count'] == 0)"
                      >
                        <v-icon size="28px">mdi-checkbox-marked-outline</v-icon>
                        <span class="lable_class">Complete</span>
                      </v-btn>
                    </template>
                    <span>Complete Task(s)</span>
                  </v-tooltip>

                  <v-menu
                    bottom
                    :close-on-content-click="false"
                    content-class="elevation-0"
                    v-model="filter_menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn size="22px" icon v-bind="attrs" v-on="on" class="header_btn">
                        <v-icon size="22px" color>mdi-filter-menu-outline</v-icon>
                        <span class="lable_class">Filter</span>
                        <!-- <v-badge
                          :content="filtersCount"
                          :value="filtersCount"
                          color="error"
                          overlap
                          size="30"
                        >
                          <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                        </v-badge>-->
                      </v-btn>
                    </template>
                    <v-card tile max-width="310" class="mb-5 mr-5">
                      <v-list class="filter-section-border">
                        <v-list-item>
                          <v-col cols="10"></v-col>
                          <v-col cols="2" class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  class="error"
                                  @click="resetFilter()"
                                  icon
                                  small
                                >
                                  <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Reset</span>
                            </v-tooltip>
                          </v-col>
                        </v-list-item>
                        <v-list-item>
                          <v-menu
                            v-model="start_menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="pagination.filters.start_date"
                                label="Start date"
                                v-bind="attrs"
                                v-on="on"
                                dense
                                outlined
                                clearable
                                hide-details
                                @click:clear="pagination.filters.start_date='';filterTaskData();"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              no-title
                              scrollable
                              dense
                              outlined
                              v-model="dateFormattedDisplay"
                              @input="start_menu = false;parseDateDisplay();filterTaskData();"
                            ></v-date-picker>
                          </v-menu>
                        </v-list-item>
                        <v-list-item>
                          <v-menu
                            v-model="end_menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="pagination.filters.end_date"
                                label="End date"
                                v-bind="attrs"
                                v-on="on"
                                dense
                                outlined
                                clearable
                                hide-details
                                class="mt-2"
                                @click:clear="pagination.filters.end_date='';filterTaskData();"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              no-title
                              scrollable
                              dense
                              outlined
                              v-model="dateFormattedDisplayEndDate"
                              @input="end_menu = false;parseDateDisplayEndDate();filterTaskData();"
                            ></v-date-picker>
                          </v-menu>
                        </v-list-item>
                        <v-list-item>
                          <v-autocomplete
                            dense
                            :items="task_list"
                            v-model="pagination.filters.task"
                            outlined
                            multiple
                            label="Task"
                            hide-details
                            clearable
                            class="mt-2"
                          >
                            <template v-slot:selection="{ index }">
                              <span
                                class="grey--text caption"
                                v-if="index == 0"
                              >{{selected_multi_values2}}</span>
                            </template>
                          </v-autocomplete>
                        </v-list-item>
                        <v-list-item>
                          <v-autocomplete
                            dense
                            :items="status_list"
                            v-model="pagination.filters.status"
                            item-text="status"
                            item-value="task_status"
                            outlined
                            hide-details
                            clearable
                            label="Status"
                            class="mt-2"
                          ></v-autocomplete>
                        </v-list-item>
                        <v-list-item>
                          <v-menu
                            v-model="menu2"
                            ref="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                outlined
                                dense
                                v-model="pagination.filters.time"
                                label="Time"
                                readonly
                                v-on="on"
                                clearable
                                hide-details
                                class="mt-2"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="menu2"
                              v-model="pagination.filters.time"
                              full-width
                              @click:minute="$refs.menu.save(pagination.filters.time)"
                            ></v-time-picker>
                          </v-menu>
                        </v-list-item>

                        <v-list-item>
                          <v-autocomplete
                            dense
                            :items="vendor_list"
                            v-model="pagination.filters.vendor"
                            outlined
                            hide-details
                            clearable
                            label="Vendor"
                            multiple
                            class="mt-2"
                          >
                            <template v-slot:selection="{ index }">
                              <span
                                class="grey--text caption"
                                v-if="index == 0"
                              >{{selected_multi_values3}}</span>
                            </template>
                          </v-autocomplete>
                        </v-list-item>
                        <v-list-item>
                          <v-autocomplete
                            dense
                            :items="user_list"
                            v-model="pagination.filters.user"
                            outlined
                            hide-details
                            clearable
                            label="User"
                            multiple
                            class="mt-2"
                          >
                            <template v-slot:selection="{ index }">
                              <span
                                class="grey--text caption"
                                v-if="index == 0"
                              >{{selected_multi_values4}}</span>
                            </template>
                          </v-autocomplete>
                        </v-list-item>
                      </v-list>
                      <v-card-title class="pa-0">
                        <v-btn
                          fab
                          color="error"
                          x-small
                          absolute
                          @click="filter_menu = false"
                          class="custom-close-btn"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                    </v-card>
                  </v-menu>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-5 header_btn"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="deleteTasks"
                        :disabled="selectedRows2.length== 0"
                      >
                        <v-icon size="28px">mdi-delete-outline</v-icon>
                        <span class="lable_class">Delete</span>
                      </v-btn>
                    </template>
                    <span>Remove Task(s)</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="openDocList(selectedRows2[0])"
                        class="ml-6 header_btn"
                        :disabled="selectedRows2.length == 0 ||  selectedRows2.length > 1"
                      >
                        <span class="lable_class">Documents</span>
                        <v-badge
                          color="error"
                          :content="(selectedRows2[0] && selectedRows2.length == 1)?selectedRows2[0].document_for_parent_count:''"
                          :value="(selectedRows2[0] && selectedRows2.length == 1)?selectedRows2[0].document_for_parent_count:''"
                          overlap
                        >
                          <v-icon size="28px">mdi-dresser-outline</v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <span>Documents</span>
                  </v-tooltip>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-6 header_btn"
                        icon
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="margin-left:25px !important;"
                      >
                        <span class="lable_class" style="color:#757575">Report</span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="28px" v-bind="attrs" v-on="on" color="#757575">mdi-printer</v-icon>
                          </template>
                          <span>Report</span>
                        </v-tooltip>
                      </v-btn>
                    </template>
                    <v-list dense style="font-size: 16px !important;">
                      <v-list-item
                        @click="note_detail=false;delay_detail=false;generateCalendarTaskReport();"
                      >
                        <v-list-item-title>Calendar Task</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="note_detail=true;delay_detail=true;generateCalendarTaskReport();"
                      >
                        <v-list-item-title>With All Detail</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="note_detail=false;delay_detail=true;generateCalendarTaskReport();"
                      >
                        <v-list-item-title>Delay Detail</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="note_detail=true;delay_detail=false;generateCalendarTaskReport();"
                      >
                        <v-list-item-title>Note Detail</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="generateCalendarTaskReport();"
                        class="ml-6 header_btn"
                      >
                        <span class="lable_class">Report</span>
                        <v-icon size="28px">mdi-printer</v-icon>
                      </v-btn>
                    </template>
                    <span>Report</span>
                  </v-tooltip>-->
                </v-col>
              </v-card-title>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 4%">
              <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 5%">
              <v-btn
                fab
                color="error"
                x-small
                @click="setTaskData({ key: 'task_list_modal', value: false })"
                class="custom-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-row no-gutters class="lighten-1 mt-2" style="margin-left: 10px;margin-right:10px;">
          <v-col cols="2" class="text-center" style="border: solid 1px grey">
            <span>Task</span>
          </v-col>
          <v-col cols="5" class="text-center" style="border: solid 1px grey">
            <span>Date</span>
          </v-col>
          <v-col cols="5" class="text-center" style="border: solid 1px grey">
            <span>Days</span>
          </v-col>
        </v-row>

        <v-row no-gutters class="grey lighten-1" style="margin-left: 10px;margin-right:10px;">
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-left: solid 1px grey"
          >
            <span>Total</span>
          </v-col>
          <v-col cols="1" class="text-center" style="border-right: solid 1px grey">
            <span>Completed</span>
          </v-col>

          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-left: solid 1px grey"
          >
            <span>Order</span>
          </v-col>
          <v-col cols="2" class="text-center" style="border-right: solid 1px grey">
            <span>Completion</span>
          </v-col>
          <v-col cols="2" class="text-center" style="border-right: solid 1px grey">
            <span>Revised Completion</span>
          </v-col>
          <v-col cols="1" class="text-center" style="border-right: solid 1px grey">
            <span>Order</span>
          </v-col>

          <v-col cols="1" class="text-center" style="border-right: solid 1px grey">
            <span>Task</span>
          </v-col>
          <v-col cols="1" class="text-center" style="border-right: solid 1px grey">
            <span>CO</span>
          </v-col>
          <v-col cols="1" class="text-center" style="border-right: solid 1px grey">
            <span>Extension</span>
          </v-col>
          <v-col cols="1" class="text-center" style="border-right: solid 1px grey">
            <span>Delay</span>
          </v-col>
        </v-row>
        <v-row no-gutters class="lighten-1" style="margin-left: 10px;margin-right:10px;">
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray;border-left: solid 1px grey"
          >
            <span>{{totalTask}}</span>
          </v-col>
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{completedTask}}</span>
          </v-col>
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray;border-left: solid 1px grey"
          >
            <span>{{ item ? item.display_date :'' }}</span>
          </v-col>

          <v-col
            cols="2"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{ item ? item.estimated_completed_date : '' }}</span>
          </v-col>
          <v-col
            cols="2"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{ revised_completion_date}}</span>
          </v-col>
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{ item? item.total_order_days : '' }}</span>
          </v-col>
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{ totalTaskDays }}</span>
          </v-col>

          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{ totalChangeOrderDays }}</span>
          </v-col>
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{ totalExtDelayDays }}</span>
          </v-col>
          <v-col
            cols="1"
            class="text-center"
            style="border-right: solid 1px grey;border-bottom: solid 1px gray"
          >
            <span>{{ totalDelayDays }}</span>
          </v-col>
        </v-row>

        <v-card-text
          class="pa-1 mx-auto"
          style="max-height: 500px !important;min-height: 500px !important;overflow: auto !important;"
        >
          <v-data-table
            :headers="headersForComplete"
            class="elevation-1 rounded-0 my-transaction-table document-list"
            :items="task_items"
            dense
            item-key="doc_id"
            :server-items-length="task_items.total"
            :options.sync="pagination"
            mobile-breakpoint="50"
            hide-default-footer
            v-if="pagination.filters.status === '4'"
            :footer-props="{
            'items-per-page-options': pagination_settings.perPageList,
            }"
          >
            <template v-slot:body="props">
              <draggable
                :list="props.items"
                tag="tbody"
                @update="handleTableUpdate(props.items)"
                @start="handleDragStart"
              >
                <tr
                  v-for="(item, index) in props.items"
                  :key="index"
                  :id="item.c_task_id"
                  :style="{ backgroundColor: item.color }"
                >
                  <td class="text-center">
                    <v-icon medium class="page__grab-icon mr-2">mdi-view-headline</v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      class="mr-2"
                      @click="editTask(item.c_task_id, item.unique_id, item.task_status,item)"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td class="text-center">
                    <v-simple-checkbox class="mr-2" v-model="item.selected" :ripple="false"></v-simple-checkbox>
                  </td>
                  <td class="text-center">{{ item.task_order }}</td>
                  <td
                    class="text-center"
                    @click="editTask(item.c_task_id, item.unique_id,item.task_status,item)"
                  >{{ item.task.task }}</td>
                  <td
                    class="text-center"
                    @click="editTask(item.c_task_id, item.unique_id,item.task_status,item)"
                  >{{ displayDateTimeFormate(item.completion_date, "date") }}</td>
                  <td class="text-center">{{item.status}}</td>
                  <td class="text-center">
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="mr-4"
                          :color="item.task_note ? 'green' : ''"
                          @click="update_task_note_modal=true;modal_task_id=item.c_task_id;modal_task_note=item.task_note;"
                        >mdi-note-text-outline</v-icon>
                      </template>
                      <span style="white-space: nowrap !important;">{{ item.task_note }}</span>
                    </v-tooltip>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mr-4"
                          v-bind="attrs"
                          v-on="on"
                          @click="getTaskAssignList(item.unique_id)"
                        >mdi-account-multiple</v-icon>
                      </template>
                      <span style="white-space: nowrap !important;">Assign List</span>
                    </v-tooltip>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="mr-4"
                          @click="taskStatusChangesList(item.unique_id)"
                        >mdi-eye</v-icon>
                      </template>
                      <span style="white-space: nowrap !important;">Task List</span>
                    </v-tooltip>
                  </td>
                </tr>
                <tr
                  v-if="task_items && task_items.length >0"
                  style="background-color:#455a64;color:#ffffff"
                >
                  <th colspan="3">Total Records:</th>
                  <th colspan="10" style="padding-left:24px !important;">{{ task_items.length }}</th>
                </tr>
              </draggable>
            </template>
          </v-data-table>

          <v-data-table
            :headers="headers"
            class="elevation-1 rounded-0 my-transaction-table document-list"
            :items="task_items"
            dense
            item-key="doc_id"
            :server-items-length="task_items.total"
            :options.sync="pagination"
            mobile-breakpoint="50"
            hide-default-footer
            v-else
            :footer-props="{
            'items-per-page-options': pagination_settings.perPageList,
            }"
          >
            <template v-slot:body="props">
              <draggable
                :list="props.items"
                tag="tbody"
                @update="handleTableUpdate(props.items)"
                @start="handleDragStart"
              >
                <tr
                  v-for="(item, index) in props.items"
                  :key="index"
                  :id="item.c_task_id"
                  :style="{ backgroundColor: item.color }"
                >
                  <td class="text-center">
                    <v-icon medium class="page__grab-icon mr-2">mdi-view-headline</v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      class="mr-2"
                      @click="editTask(item.c_task_id, item.unique_id,item.task_status, item)"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td class="text-center">
                    <v-simple-checkbox class="mr-2" v-model="item.selected" :ripple="false"></v-simple-checkbox>
                  </td>
                  <td class="text-center">{{ item.task_order }}</td>
                  <td
                    class="text-center"
                    @click="editTask(item.c_task_id, item.unique_id,item.task_status, item)"
                  >{{ item.task.task }}</td>
                  <td
                    class="text-center"
                    @click="editTask(item.c_task_id, item.unique_id, item.task_status, item)"
                  >{{ displayDateTimeFormate(item.start_date, "date") }}</td>
                  <td class="text-center">{{item.working_days }}</td>
                  <td class="text-center">{{ displayDateTimeFormate(item.end_date) }}</td>
                  <td class="text-center">{{ item.task_time }}</td>

                  <td class="text-center">{{item.status}}</td>
                  <td class>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="mr-4"
                          :color="item.task_note ? 'green' : ''"
                          @click="update_task_note_modal=true;modal_task_id=item.c_task_id;modal_task_note=item.task_note;"
                        >mdi-note-text-outline</v-icon>
                      </template>
                      <span style="white-space: nowrap !important;">{{ item.task_note }}</span>
                    </v-tooltip>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mr-4"
                          v-bind="attrs"
                          v-on="on"
                          @click="getTaskAssignList(item.unique_id)"
                        >mdi-account-multiple</v-icon>
                      </template>
                      <span style="white-space: nowrap !important;">Assign List</span>
                    </v-tooltip>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="mr-4"
                          @click="taskStatusChangesList(item.unique_id)"
                        >mdi-eye</v-icon>
                      </template>
                      <span style="white-space: nowrap !important;">Task List</span>
                    </v-tooltip>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="mr-4"
                          @click="taskNoteList(item.unique_id, item.task.task)"
                        >mdi-view-list</v-icon>
                      </template>
                      <span style="white-space: nowrap !important;">Note List</span>
                    </v-tooltip>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          height="20"
                          variant="text"
                          width="20"
                          class="mr-4"
                          border
                          :style="{ backgroundColor:'#fca506',color:'#000000',minWidth:'10px !important'}"
                        >
                          <span style="font-size:12px !important;">{{item.delay_all_task_count}}</span>
                        </v-btn>
                      </template>
                      <span style="white-space: nowrap !important;">Delay Days</span>
                    </v-tooltip>
                    <v-tooltip right max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          height="20"
                          variant="text"
                          width="20"
                          class="mr-4"
                          border
                          :style="{ backgroundColor: '#a61f38',color:'#000000',minWidth:'10px !important'}"
                        >
                          <span style="font-size:12px !important;">{{item.ext_delay_all_task_count}}</span>
                        </v-btn>
                      </template>
                      <span style="white-space: nowrap !important;">Extension Delay Days</span>
                    </v-tooltip>
                  </td>
                </tr>
                <tr
                  v-if="task_items && task_items.length >0"
                  style="background-color:#455a64;color:#ffffff"
                >
                  <th colspan="3">Total Record:</th>
                  <th colspan="10" style="padding-left:24px !important;">{{ task_items.length }}</th>
                </tr>
              </draggable>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-overlay absolute :value="loading">
        <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
      </v-overlay>
    </v-dialog>
    <v-dialog v-model="assign_list_popup" max-width="350" persistent>
      <v-card class="mx-auto align-self-stretch" tile width="100%">
        <v-card-title class="headline-1 pa-2">Assign List</v-card-title>
        <v-card-text class="pa-2 pt-0" style="font-weight: 500">
          <v-row dense class="light-green lighten-4 primary--text">
            <v-col cols="12" class="pt-2" v-for="(assign, index) in assign_list" :key="index">
              <v-btn
                class="mx-2"
                fab
                dark
                x-small
                width="22"
                height="22"
                color="primary"
                @click="removeTaskAssign(assign.id)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
              <span class="ml-2">{{ assign.name }}</span>
            </v-col>
          </v-row>
          <!-- <v-row dense v-else>
            <v-col cols="12">
              No Any Allowed IP Address!
            </v-col>
          </v-row>-->
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click="assign_list_popup = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="update_task_note_modal" persistent max-width="500px">
      <v-card :loading="update_task_loading">
        <v-card-title>
          <span class="headline-1">Update Task Note</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea dense hide-details v-model="modal_task_note" outlined rows="3"></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="update_task_note_modal = false;">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="update_task_loading" @click="UpdateTasknote()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delay_task_popup" persistent max-width="404px">
      <v-card :loading="update_task_loading">
        <v-card-title class="custom-padding">
          <v-col cols="11" class="custom-padding">
            <span class="headline-1">Delay Task Note</span>
          </v-col>
          <v-col cols="1" style="max-width: 4%" class="p-0">
            <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
          </v-col>
        </v-card-title>
        <v-card-text class="custom-padding">
          <v-container>
            <v-row>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  v-model="previous_start_date"
                  label="Est. St. Dt"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  dense
                  v-model="previous_task_days"
                  outlined
                  label="W.Days"
                  type="number"
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  v-model="previous_end_date"
                  label="Comp. Date"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="top-padding">
                Do you want to add delay on Start date or End date?
                <v-radio-group
                  v-model="start_or_end_delay"
                  row
                  hide-details
                  class="mt-0"
                  dense
                  @change="changeStartAndEndDate()"
                >
                  <v-radio label="Start Date" value="start_date" class="ma-0"></v-radio>
                  <v-radio label="End Date" value="end_date" class="ma-0 pa-0 pl-2"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="4" class="custom-padding top-padding">
                <v-text-field
                  dense
                  v-model="task_days"
                  outlined
                  label="Delay Days"
                  type="number"
                  @keyup="changeStartAndEndDate();"
                  @input="changeStartAndEndDate();"
                  :error-messages="form_error.task_days"
                  :hide-details="!form_error.task_days"
                ></v-text-field>
              </v-col>

              <v-col cols="4" class="custom-padding top-padding">
                <v-menu
                  ref="start_menu1"
                  v-model="start_menu1"
                  :close-on-content-click="false"
                  :return-value.sync="delay_start_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="delay_start_date"
                      label="Start Date"
                      v-bind="attrs"
                      v-on="on"
                      @input="$refs.start_menu1.save(delay_start_date);"
                      dense
                      outlined
                      :error-messages="form_error.delay_start_date"
                      :hide-details="!form_error.delay_start_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplayStartDate1"
                    @input="parseDateDisplayStartDate1();$refs.start_menu1.save(delay_start_date);"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="4" class="custom-padding top-padding">
                <v-menu
                  ref="end_menu1"
                  v-model="end_menu1"
                  :close-on-content-click="false"
                  :return-value.sync="delay_end_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="delay_end_date"
                      label="Comp. Date"
                      v-bind="attrs"
                      v-on="on"
                      @input="$refs.end_menu1.save(delay_end_date);"
                      dense
                      outlined
                      :error-messages="form_error.end_date"
                      :hide-details="!form_error.end_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplayEndDate1"
                    @input="parseDateDisplayEndDate1();$refs.end_menu1.save(delay_end_date);getDelayDaysValue();"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="top-padding">
                Delay Due to
                <v-radio-group v-model="delay_reason" row hide-details class="mt-0" dense>
                  <v-radio label="Customer" value="customer" class="ma-0"></v-radio>
                  <v-radio label="Vendor" value="vendor" class="ma-0 pa-0 pl-2"></v-radio>
                  <v-radio label="Material" value="material" class="ma-0 pa-0 pl-2"></v-radio>
                  <v-radio label="Company" value="company" class="ma-0 pa-0"></v-radio>
                  <v-radio label="Other" value="other" class="ma-0 pa-0 pl-2"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" class="top-padding">
                Do you want to extend completion date?
                <v-radio-group v-model="is_ext_delay" row hide-details class="mt-0" dense>
                  <v-radio label="Yes" value="true" class="ma-0"></v-radio>
                  <v-radio label="No" value="false" class="ma-0 pa-0 pl-2"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" class="top-padding">
                Do you want to add delay on subsequence task?
                <v-radio-group v-model="is_add_delay" row hide-details class="mt-0" dense>
                  <v-radio label="Yes" value="true" class="ma-0"></v-radio>
                  <v-radio label="No" value="false" class="ma-0 pa-0 pl-2"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="4" class="top-padding">
                <v-text-field
                  dense
                  v-model="add_delay"
                  outlined
                  label="Delay Days"
                  type="number"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="top-padding">
                <v-textarea
                  dense
                  v-model="delay_task_note"
                  outlined
                  label="Notes"
                  rows="3"
                  :error-messages="form_error.task_note"
                  :hide-details="!form_error.task_note"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <span style="display: inline-block">
                  <v-checkbox v-model="task_customer" class="mt-0 pt-0"></v-checkbox>
                </span>
                <span style="display: inline-block; width: 88%">
                  <v-text-field v-model="customer_name" label="Customer" dense outlined readonly></v-text-field>
                </span>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  dense
                  :items="vendor_list"
                  v-model="task_vendor"
                  item-text="text"
                  item-value="value"
                  multiple
                  outlined
                  label="Select Vendor"
                  @change="updateVendorList"
                >
                  <!-- <template v-slot:item="{ item }">
                  <span style="width: 100%">
                    <span>{{ item.text }}</span>
                    <span class="float-right pl-2">
                      <span class="primary--text">{{ item.mobile }}</span>
                    </span>
                  </span>
                  </template>-->
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text"
                    >(+{{ task_vendor.length - 1 }} others)</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="delay_task_note='';delay_task_id='';add_delay=1;task_days=1;delay_task_popup = false;"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="update_task_loading" @click="delayTask(5)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="schedule_task_popup" persistent max-width="404px">
      <v-card :loading="update_task_loading">
        <v-card-title class="custom-padding">
          <v-col cols="11" class="custom-padding">
            <span class="headline-1">{{schedule_lable == 2 ? 'Schedule' : 'Reschedule' }} Task</span>
          </v-col>
          <v-col cols="1" style="max-width: 4%" class="p-0">
            <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
          </v-col>
        </v-card-title>
        <v-card-text class="custom-padding">
          <v-container>
            <v-row>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  v-model="previous_start_date"
                  label="Est. St. Dt"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  dense
                  v-model="previous_task_days"
                  outlined
                  label="W.Days"
                  type="number"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  v-model="previous_end_date"
                  label="Comp. Date"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="4" class="custom-padding top-padding">
                <v-menu
                  ref="start_menu1"
                  v-model="start_menu1"
                  :close-on-content-click="false"
                  :return-value.sync="delay_start_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="delay_start_date"
                      label="Start Date"
                      v-bind="attrs"
                      v-on="on"
                      @input="$refs.start_menu1.save(delay_start_date);"
                      dense
                      outlined
                      :error-messages="form_error.delay_start_date"
                      :hide-details="!form_error.delay_start_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplayStartDate1"
                    @input="parseDateDisplayStartDate1();changeScheduleDate();$refs.start_menu1.save(delay_start_date);"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4" class="custom-padding top-padding">
                <v-text-field
                  dense
                  v-model="task_days"
                  outlined
                  label="Schedule Days"
                  type="number"
                  @keyup="changeScheduleDate();"
                  @input="changeScheduleDate();"
                  :error-messages="form_error.task_days"
                  :hide-details="!form_error.task_days"
                ></v-text-field>
              </v-col>

              <v-col cols="4" class="custom-padding top-padding">
                <v-menu
                  ref="end_menu1"
                  v-model="end_menu1"
                  :close-on-content-click="false"
                  :return-value.sync="delay_end_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="delay_end_date"
                      label="Comp. Date"
                      v-bind="attrs"
                      v-on="on"
                      @input="$refs.end_menu1.save(delay_end_date);"
                      dense
                      outlined
                      :error-messages="form_error.end_date"
                      :hide-details="!form_error.end_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplayEndDate1"
                    @input="parseDateDisplayEndDate1();$refs.end_menu1.save(delay_end_date);getDelayDaysValue();"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" class="top-padding">
                <v-textarea
                  dense
                  v-model="delay_task_note"
                  outlined
                  label="Notes"
                  rows="3"
                  :error-messages="form_error.task_note"
                  :hide-details="!form_error.task_note"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <span style="display: inline-block">
                  <v-checkbox v-model="task_customer" class="mt-0 pt-0"></v-checkbox>
                </span>
                <span style="display: inline-block; width: 88%">
                  <v-text-field v-model="customer_name" label="Customer" dense outlined readonly></v-text-field>
                </span>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  dense
                  :items="vendor_list"
                  v-model="task_vendor"
                  item-text="text"
                  item-value="value"
                  multiple
                  outlined
                  label="Select Vendor"
                  @change="updateVendorList"
                >
                  <!-- <template v-slot:item="{ item }">
                  <span style="width: 100%">
                    <span>{{ item.text }}</span>
                    <span class="float-right pl-2">
                      <span class="primary--text">{{ item.mobile }}</span>
                    </span>
                  </span>
                  </template>-->
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text"
                    >(+{{ task_vendor.length - 1 }} others)</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="delay_task_note='';delay_task_id='';schedule_task_popup = false;task_days=1;delay_start_date=null;delay_end_date=null;"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="update_task_loading"
            @click="delayTask(schedule_lable)"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delay_task_note_popup" persistent max-width="500px">
      <v-card :loading="update_task_loading">
        <v-card-title>
          <span class="headline-1">Delay Note List</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-list dense>
              <v-list-item-group v-if="delay_task_note_list.length > 0">
                <v-list-item v-for="(note, index) in delay_task_note_list" :key="index">
                  <v-list-item-content>{{index+1}}. {{ note.task_note }}</v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-list-item v-else>
                <v-list-item-content>No notes available</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="delay_task_id='';delay_task_note_list=[];delay_task_note_popup = false;"
          >Close</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="complete_task_popup" persistent max-width="500px">
      <v-card :loading="update_task_loading">
        <v-card-title>
          <v-col cols="11" class="p-0">
            <span class="headline-1">Complete Task</span>
          </v-col>
          <v-col cols="1" style="max-width: 4%" class="p-0">
            <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
          </v-col>
        </v-card-title>
        <v-card-text class="custom-padding">
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="previous_start_date"
                  label="start date"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  dense
                  v-model="previous_task_days"
                  outlined
                  label="W.Days"
                  type="number"
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="previous_end_date"
                  label="End date"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-menu
                  v-model="start_menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="new_completion_date"
                      label="Completion Date"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      :error-messages="form_error.new_completion_date"
                      :hide-details="!form_error.new_completion_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    :max="getCurrentDate()"
                    v-model="dateFormattedDisplay2"
                    @input="start_menu2 = false;parseDateDisplay2();calculateCompletionDate();"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- <v-col cols="4">
                <v-text-field
                  dense
                  v-model="completion_days"
                  outlined
                  label="Completion Days"
                  type="number"
                  disabled
                ></v-text-field>
              </v-col>-->
              <v-col cols="12">
                <v-textarea
                  dense
                  v-model="completion_note"
                  outlined
                  label="Task Note"
                  rows="2"
                  :error-messages="form_error.completion_note"
                  :hide-details="!form_error.completion_note"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="completeTask()">Save</v-btn>
          <v-btn color="error" @click="complete_task_popup = false;">Close</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="change_order_popup" persistent max-width="400px">
      <v-card :loading="update_task_loading">
        <v-card-title>
          <v-col cols="11" class="p-0">
            <span class="headline-1">Task</span>
          </v-col>
          <v-col cols="1" style="max-width: 4%" class="p-0">
            <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
          </v-col>
        </v-card-title>
        <v-card-text class="custom-padding">
          <v-container>
            <v-row style="display:flex;justify-content:center">
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  v-model="current_order_start_date"
                  label="Est.Start Date"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding" style="max-width:90px !important;">
                <v-text-field
                  dense
                  v-model="current_order_task_days"
                  outlined
                  label="TTL Days"
                  type="number"
                  disabled
                  @keyup="changeEndDate3();"
                  @input="changeEndDate3();"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding">
                <v-text-field
                  v-model="current_order_end_date"
                  label="Comp. Date"
                  dense
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row style="display:flex;justify-content:center">
              <v-col cols="4" class="custom-padding">
                <v-menu
                  v-model="start_menu3"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template>
                    <v-text-field
                      v-model="previous_order_start_date"
                      label="New Est.Start Date"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplay3"
                    @input="start_menu3 = false;parseDateDisplay3();changeEndDate3();"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4" class="custom-padding" style="max-width:90px !important;">
                <v-text-field
                  dense
                  v-model="previous_order_task_days"
                  outlined
                  label="New TTL Days"
                  type="number"
                  @keyup="changeEndDate3();"
                  @input="changeEndDate3();"
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="custom-padding">
                <v-menu
                  v-model="end_menu3"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="previous_order_end_date"
                      label="New Comp. Date"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      :error-messages="form_error.previous_order_end_date"
                      :hide-details="!form_error.previous_order_end_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    scrollable
                    dense
                    outlined
                    v-model="dateFormattedDisplayEndDate3"
                    @input="end_menu3 = false;parseDateDisplayEndDate3();changePreviousOrderTaskDays();"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding-top:0px;">
          <v-btn color="primary" @click="changeOrderWithDate()">Save</v-btn>
          <v-btn
            color="error"
            @click="change_order_popup = false;filterTaskData();previous_start_date=null;previous_end_date=null;previous_task_days=1;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddTask @getTaskList="filterTaskData();" />
    <TaskAllStatusList
      :task_all_status_list_popup="task_all_status_list_popup"
      :unique_id="unique_calendar_id"
      :o_id="o_id"
      @closeTaskAllStatusListPopup="
      task_all_status_list_popup = false;"
    />
    <TaskNoteList
      :task_note_list_popup="task_note_list_popup"
      :unique_id="unique_calendar_id"
      :o_id="o_id"
      :task_name="task_name"
      @closeTaskNoteListPopup="closeTaskNoteListPopup();"
    />
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { mapState, mapMutations, mapActions } from "vuex";
import { parseParams, daysBetweenDates } from "../../plugins/helper";
import AddTask from "../task/AddTask";
import TaskAllStatusList from "../task/TaskAllStatusList";
import TaskNoteList from "../task/TaskNoteList";
import draggable from "vuedraggable";
const moment = require("moment");
export default {
  name: "TaskList",
  data: () => ({
    headers: [
      {
        value: "",
        text: "",
        sortable: false,
        width: "2%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "edit",
        text: "",
        sortable: false,
        width: "2%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "checkbox",
        text: "#",
        sortable: false,
        width: "2%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "task_order",
        text: "Sq.",
        sortable: true,
        width: "5%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "task",
        text: "Task",
        sortable: true,
        width: "32%",
        align: "center",
        padding: "0px 5px"
      },

      {
        value: "start_date",
        text: "St. Dt",
        sortable: true,
        width: "7%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "working_days",
        text: "W.Days",
        sortable: false,
        width: "5%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "start_date",
        text: "Comp.Dt.",
        sortable: true,
        width: "8%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "",
        text: "Time",
        sortable: false,
        width: "5%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "task_status",
        text: "Status",
        sortable: true,
        width: "7%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "",
        text: "Info",
        sortable: false,
        width: "29%",
        align: "center",
        padding: "0px 5px"
      }
    ],
    headersForComplete: [
      {
        value: "",
        text: "",
        sortable: false,
        width: "2%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "edit",
        text: "",
        sortable: false,
        width: "2%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "checkbox",
        text: "#",
        sortable: false,
        width: "2%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "task_order",
        text: "Sq.",
        sortable: true,
        width: "5%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "task",
        text: "Task",
        sortable: true,
        width: "45%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "completion_date",
        text: "Completion date",
        sortable: true,
        width: "20%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "task_status",
        text: "Status",
        sortable: true,
        width: "7%",
        align: "center",
        padding: "0px 5px"
      },
      {
        value: "",
        text: "Action",
        sortable: false,
        width: "20%",
        align: "center",
        padding: "0px 5px"
      }
    ],
    search: "",
    unique_calendar_id: "",
    task_all_status_list_popup: false,
    task_note_list_popup: false,
    assign_list_popup: false,
    assign_calendar_id: "",
    assign_list: [],
    task_order: "",
    update_task_note_modal: false,
    update_task_loading: false,
    modal_task_id: "",
    modal_task_note: "",
    open_task_count: 0,
    task_list: [],
    // vendor_list: [],
    // user_list: [],
    start_menu: false,
    end_menu: false,
    start_menu1: false,
    end_menu1: false,
    start_menu2: false,
    start_menu3: false,
    end_menu3: false,
    dateFormattedDisplay: null,
    dateFormattedDisplayEndDate: null,
    dateFormattedDisplay1: null,
    dateFormattedDisplayEndDate1: null,
    dateFormattedDisplayStartDate1: null,
    dateFormattedDisplay2: null,
    dateFormattedDisplay3: null,
    dateFormattedDisplayEndDate3: null,
    time: null,
    menu2: false,
    modal2: false,
    filter_menu: false,
    delay_task_popup: false,
    delay_task_id: "",
    delay_task_note: "",
    delay_task_note_popup: "",
    delay_task_note_list: [],
    task_days: 1,
    end_date: null,
    start_date: null,
    delay_end_date: null,
    delay_start_date: null,
    task_vendor: [],
    task_customer: false,
    completion_date: null,
    new_completion_date: moment(new Date()).format("MM/DD/YYYY"),
    completion_days: 0,
    completion_note: "",
    complete_task_popup: false,
    previous_start_date: null,
    previous_task_days: 0,
    previous_end_date: null,
    previous_order_start_date: null,
    previous_order_end_date: null,
    change_order_popup: false,
    previous_order_task_days: 1,
    delay_reason: "customer",
    start_or_end_delay: "start_date",
    is_ext_delay: "false",
    is_add_delay: "false",
    add_delay: 1,
    note_detail: true,
    task_name: "",
    delay_detail: true,
    form_error: {},
    taskArr: [],
    schedule_lable: "",
    current_order_start_date: null,
    current_order_end_date: null,
    current_order_task_days: 1,
    schedule_task_popup: false,
    pagination: {
      itemsPerPage: -1,
      sortBy: ["task_order"],
      page: 1,
      search: "",
      filters: {
        task: [],
        vendor: [],
        user: [],
        status: "1",
        start_date: null,
        end_date: null
      }
    },
    draggedItem: null,
    is_add_edit: "add",

    status_list: []
    // status_list: [
    //   {
    //     text: "Open",
    //     value: "1",
    //     children: []
    //   },
    //   {
    //     text: "Schedule",
    //     value: "2"
    //   },
    //   {
    //     text: "Delay",
    //     value: "5"
    //   },
    //   {
    //     text: "Reschedule",
    //     value: "3"
    //   },
    //   {
    //     text: "Complete",
    //     value: "4"
    //   },
    //   {
    //     text: "All",
    //     value: "all"
    //   }
    // ]
  }),
  components: {
    AddTask,
    TaskAllStatusList,
    draggable,
    TaskNoteList
  },
  props: ["vendor_list", "user_list", "project_list"],
  watch: {
    task_list_modal: {
      handler(val) {
        this.pagination.filters = {
          status: 1,
          task: [],
          vendor: [],
          user: []
        };
        if (!val) {
          this.setTaskData({ key: "form_errors", value: [] });
        } else {
          this.getProjectList();
          this.setAddTaskData({
            key: "user_list",
            value: this.user_list
          });

          this.setAddTaskData({
            key: "vendor_list",
            value: this.vendor_list
          });
          this.setAddTaskData({
            key: "project_list",
            value: this.project_list
          });

          this.pagination.filters.status = "1";
          this.getAllTask();
        }
      }
    },
    refresh_task_list: {
      handler() {
        this.setTaskData({ key: "form_errors", value: [] });
      }
    },
    pagination: {
      handler() {
        this.getTasks(parseParams(this.pageData));
      },
      deep: true
    }
  },
  computed: {
    ...mapState("task", [
      "task_list_loading",
      "task_list_modal",
      "form_name",
      "bank_name",
      "project_name",
      "vendor_name",
      "item_name",
      "job_name",
      "user_name",
      "customer_name",
      "item",
      "task_items",
      "type",
      "refresh_task_list",
      // "display_date",
      // "estimated_completed_date",
      // "revised_completion_date",
      "o_id",
      "unique_id",
      "task_count",
      "totalTaskDays",
      "totalDelayDays",
      "totalExtDelayDays",
      "totalTask",
      "completedTask",
      "loading",
      "totalChangeOrderDays"
    ]),
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("addtask", ["add_calendar_task_modal"]),

    getTotaldays() {
      return daysBetweenDates(
        this.item.display_date,
        this.item.estimated_completed_date
      );
    },
    // getRescheduleDays() {
    //   if (
    //     this.item.estimated_completed_date &&
    //     this.item.revised_completion_date
    //   ) {
    //     return daysBetweenDates(
    //       this.item.estimated_completed_date,
    //       this.item.revised_completion_date
    //     );
    //   } else {
    //     return "";
    //   }
    // },
    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
    selectedRows2() {
      let returnData = [];
      let _self = this;
      if (this.task_items) {
        let count = 0;
        this.task_items.filter(function(item) {
          if (item.selected) {
            returnData.push(item);
            if (item.task_status != 1) {
              count++;
              _self.open_task_count = count;
            }
          }
        });
      }
      return returnData;
    },
    selected_multi_values2() {
      let return_data = "";
      let _self = this;
      if (_self.pagination.filters.task.length > 0) {
        _self.task_list.filter(item => {
          if (item.value == _self.pagination.filters.task[0]) {
            return_data = item.text;
          }
        });
        if (_self.pagination.filters.task.length > 1) {
          let totalVen = _self.pagination.filters.task.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    selected_multi_values3() {
      let return_data = "";
      let _self = this;
      if (_self.pagination.filters.vendor.length > 0) {
        _self.vendor_list.filter(item => {
          if (item.value == _self.pagination.filters.vendor[0]) {
            return_data = item.text;
          }
        });
        if (_self.pagination.filters.vendor.length > 1) {
          let totalVen = _self.pagination.filters.vendor.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    selected_multi_values4() {
      let return_data = "";
      let _self = this;
      if (_self.pagination.filters.user.length > 0) {
        _self.user_list.filter(item => {
          if (item.value == _self.pagination.filters.user[0]) {
            return_data = item.text;
          }
        });
        if (_self.pagination.filters.user.length > 1) {
          let totalVen = _self.pagination.filters.user.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    revised_completion_date() {
      let _self = this;
      let estimated_completed_date = _self.item.estimated_completed_date;
      let totalExtDelayDays = _self.totalExtDelayDays;
      let totalChangeOrderDays = _self.totalChangeOrderDays;
      let totalDays =
        parseInt(totalExtDelayDays) + parseInt(totalChangeOrderDays);
      return moment(
        moment(estimated_completed_date, "MM/DD/YYYY").add(totalDays, "days")
      ).format("MM/DD/YYYY");
    }
  },
  methods: {
    ...mapActions("task", ["getTasks", "getTotalTaskDays"]),
    ...mapMutations("task", ["setTaskData"]),
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("addtask", ["setAddTaskData"]),
    ...mapMutations("document", ["setDocumentData"]),
    openDocList(item) {
      this.setDocumentData({ key: "main_task_id", value: item.unique_id });
      this.setDocumentData({ key: "child_task_id", value: 0 });
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 8 });
      this.setDocumentData({ key: "o_id", value: item.o_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "form_name", value: "Calendar Task" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: this.customer_name });
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: this.project_name });
      this.setDocumentData({ key: "vendor_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "CALENDARTASK" });
      // this.$router.push({name: 'projects_document'});
    },
    generateCalendarTaskReport() {
      this.loading = true;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let url =
        "o_id=" +
        this.o_id +
        "&type=8" +
        "&user_name=" +
        localStorage.getItem("user_id") +
        "&company_id=" +
        company_data.company_id +
        "&project_data_flag=" +
        this.project_data_flag +
        "&report_header_name=" +
        this.report_header_name +
        "&note_detail=" +
        this.note_detail +
        "&delay_detail=" +
        this.delay_detail +
        "&" +
        parseParams(this.pageData);
      axios
        .get("generate_calendar_task_detail_pdf?" + url)
        .then(response => {
          if (response.data.status) {
            var File_url = response.data.file_url;
            window.open(File_url, "Download");
            this.loading = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      // window.open(
      //     process.env.VUE_APP_BASEURL+'/generate_group_item_pdf?project_id='+this.selectedRows[0].project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&project_data_flag='+this.project_data_flag+'&is_with_cost='+this.is_with_cost+'&is_with_qty='+this.is_with_qty+'&is_item_spent='+this.is_item_spent,
      //     '_blank'
      // );
    },
    resetFilter() {
      this.pagination.filters = {
        task: [],
        vendor: [],
        user: [],
        status: "1"
      };
    },
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    handleDragStart(event) {
      this.draggedItem = event.item.getAttribute("id");
    },
    changeEndDate() {
      this.end_date = moment(
        moment(this.start_date, "MM/DD/YYYY").add(
          this.form_data.task_days,
          "days"
        )
      ).format("MM/DD/YYYY");
      this.dateFormattedDisplayEndDate = moment(
        moment(this.start_date, "MM/DD/YYYY").add(
          this.form_data.task_days,
          "days"
        )
      ).format("YYYY-MM-DD");
    },
    changeScheduleDate() {
      this.delay_end_date = moment(
        moment(this.delay_start_date, "MM/DD/YYYY").add(this.task_days, "days")
      ).format("MM/DD/YYYY");
      this.dateFormattedDisplayEndDate1 = moment(
        moment(this.delay_end_date, "MM/DD/YYYY").add(this.task_days, "days")
      ).format("YYYY-MM-DD");
    },
    changeStartAndEndDate() {
      if (this.start_or_end_delay == "start_date") {
        this.delay_start_date = moment(
          moment(this.previous_start_date, "MM/DD/YYYY").add(
            this.task_days,
            "days"
          )
        ).format("MM/DD/YYYY");
        this.dateFormattedDisplayStartDate1 = moment(
          moment(this.previous_start_date, "MM/DD/YYYY").add(
            this.task_days,
            "days"
          )
        ).format("YYYY-MM-DD");
      } else {
        this.delay_start_date = moment(
          moment(this.previous_start_date, "MM/DD/YYYY").add(0, "days")
        ).format("MM/DD/YYYY");
        this.dateFormattedDisplayStartDate1 = moment(
          moment(this.previous_start_date, "MM/DD/YYYY").add(0, "days")
        ).format("YYYY-MM-DD");
      }

      this.delay_end_date = moment(
        moment(this.previous_end_date, "MM/DD/YYYY").add(this.task_days, "days")
      ).format("MM/DD/YYYY");
      this.dateFormattedDisplayEndDate1 = moment(
        moment(this.previous_end_date, "MM/DD/YYYY").add(this.task_days, "days")
      ).format("YYYY-MM-DD");
      this.add_delay = this.task_days;
    },

    // changeEndDate1() {
    //   this.delay_end_date = moment(
    //     moment(this.delay_start_date, "MM/DD/YYYY").add(this.task_days, "days")
    //   ).format("MM/DD/YYYY");
    //   this.dateFormattedDisplayEndDate1 = moment(
    //     moment(this.delay_start_date, "MM/DD/YYYY").add(this.task_days, "days")
    //   ).format("YYYY-MM-DD");
    //   this.add_delay = this.task_days;
    // },
    changeEndDate3() {
      this.previous_order_end_date = moment(
        moment(this.previous_order_start_date, "MM/DD/YYYY").add(
          this.previous_order_task_days,
          "days"
        )
      ).format("MM/DD/YYYY");
      this.dateFormattedDisplayEndDate3 = moment(
        moment(this.previous_order_start_date, "MM/DD/YYYY").add(
          this.previous_order_task_days,
          "days"
        )
      ).format("YYYY-MM-DD");
    },
    getDelayDaysValue() {
      let _self = this;
      const delay_start_date = _self.delay_start_date;
      const delay_end_date = _self.delay_end_date;

      // Split the date strings into components
      const [startMonth, startDay, startYear] = delay_start_date.split("/");
      const [endMonth, endDay, endYear] = delay_end_date.split("/");

      // Create Date objects
      const startDate = new Date(`${startMonth}/${startDay}/${startYear}`);
      const endDate = new Date(`${endMonth}/${endDay}/${endYear}`);

      // Calculate the difference in milliseconds
      const differenceInMs = endDate - startDate;

      // Convert milliseconds to days
      const millisecondsInOneDay = 1000 * 60 * 60 * 24;
      const differenceInDays = Math.floor(
        differenceInMs / millisecondsInOneDay
      );
      _self.task_days = differenceInDays;
    },
    changePreviousOrderTaskDays() {
      let _self = this;
      const previous_order_start_date = _self.previous_order_start_date;
      const previous_order_end_date = _self.previous_order_end_date;

      // Split the date strings into components
      const [startMonth, startDay, startYear] = previous_order_start_date.split(
        "/"
      );
      const [endMonth, endDay, endYear] = previous_order_end_date.split("/");

      // Create Date objects
      const startDate = new Date(`${startMonth}/${startDay}/${startYear}`);
      const endDate = new Date(`${endMonth}/${endDay}/${endYear}`);

      // Calculate the difference in milliseconds
      const differenceInMs = endDate - startDate;

      // Convert milliseconds to days
      const millisecondsInOneDay = 1000 * 60 * 60 * 24;
      const differenceInDays = Math.floor(
        differenceInMs / millisecondsInOneDay
      );
      _self.previous_order_task_days = differenceInDays;
    },
    UpdateTasknote() {
      let _self = this;
      axios
        .post("calendar_task/update_task_note", {
          task_id: _self.modal_task_id,
          task_note: _self.modal_task_note
        })
        .then(function(res) {
          if (res.data.status) {
            _self.getTasks(parseParams(_self.pageData));
            _self.update_task_loading = false;
            _self.update_task_note_modal = false;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },

    async handleTableUpdate(val) {
      let _self = this;
      _self.taskArr = val.map(({ unique_id, task_order }) => {
        return { unique_id: unique_id, task_order: task_order };
      });

      let previousTaskId;
      let currentTaskId;
      for (let i = 0; i < val.length; i++) {
        if (val[i].c_task_id == _self.draggedItem) {
          currentTaskId = val[i];
          previousTaskId = val[i - 1];
          break;
        }
      }
      _self.current_order_start_date = moment(currentTaskId.start_date).format(
        "MM/DD/YYYY"
      );
      _self.current_order_end_date = moment(currentTaskId.end_date).format(
        "MM/DD/YYYY"
      );
      _self.current_order_task_days = currentTaskId.task_days;

      _self.previous_order_start_date = moment(
        moment(previousTaskId.end_date, "YYYY-MM-DD").add(1, "days")
      ).format("MM/DD/YYYY");

      _self.changeEndDate3();
      _self.change_order_popup = true;
    },
    changeOrderWithDate() {
      let _self = this;
      try {
        axios
          .post("calendar_task/change_task_order", {
            taskArr: _self.taskArr,
            type: _self.type,
            o_id: _self.o_id,
            status: _self.pagination.filters.status
          })
          .then(function(res) {
            if (res.data.status) {
              axios
                .post("calendar_task/change_order_with_date", {
                  previous_order_start_date: moment(
                    _self.previous_order_start_date
                  ).format("YYYY-MM-DD HH:mm:ss"),
                  previous_order_task_days: _self.previous_order_task_days,
                  c_task_id: _self.draggedItem
                })
                .then(function(res) {
                  if (res.data.status) {
                    _self.getTasks(parseParams(_self.pageData));
                    _self.update_task_loading = false;
                    _self.previous_start_date = null;
                    _self.previous_end_date = null;
                    _self.previous_task_days = 1;
                    _self.update_task_loading = false;
                    _self.update_task_note_modal = false;
                    _self.change_order_popup = false;
                  }
                })
                .catch(function() {
                  console.log("FAILURE!!");
                });
            }
          })
          .catch(function() {
            console.log("FAILURE!!");
          });
      } catch (error) {
        console.log("FAILURE!!", error);
      }
    },

    parseDateDisplay() {
      const [year, month, day] = this.dateFormattedDisplay.split("-");
      this.pagination.filters.start_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    parseDateDisplayEndDate() {
      const [year, month, day] = this.dateFormattedDisplayEndDate.split("-");
      this.pagination.filters.end_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    parseDateDisplay1() {
      const [year, month, day] = this.dateFormattedDisplay1.split("-");
      this.delay_start_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    parseDateDisplayStartDate1() {
      const [year, month, day] = this.dateFormattedDisplayStartDate1.split("-");
      this.delay_start_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    parseDateDisplayEndDate1() {
      const [year, month, day] = this.dateFormattedDisplayEndDate1.split("-");
      this.delay_end_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    parseDateDisplay2() {
      const [year, month, day] = this.dateFormattedDisplay2.split("-");
      this.new_completion_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    parseDateDisplay3() {
      const [year, month, day] = this.dateFormattedDisplay3.split("-");
      this.previous_order_start_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    parseDateDisplayEndDate3() {
      const [year, month, day] = this.dateFormattedDisplayEndDate3.split("-");
      this.previous_order_end_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },

    // UpdateTaskOrder(val, unique_id) {
    //   if (val != "") {
    //     let _self = this;
    //     axios
    //       .post("calendar_task/change_task_order", {
    //         val: val,
    //         unique_id: unique_id,
    //         type: _self.type,
    //         o_id: _self.o_id
    //       })
    //       .then(function(response) {
    //         _self.setTaskData({
    //           key: "task_count",
    //           value: response.data.task_count
    //         });
    //         _self.getTasks();
    //       })
    //       .catch(function() {
    //         console.log("FAILURE!!");
    //       });
    //   }
    // },

    displayDateTimeFormate(date, flag) {
      if (flag == "time") {
        return moment(date).format("H:mm:ss");
      } else if (flag == "datetime") {
        return moment(date).format("MM/DD/YYYY H:mm");
      } else {
        return moment(date).format("MM/DD/YYYY");
      }
    },
    deleteTasks() {
      let _self = this;
      let ids = [];
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      this.selectedRows2.map(function(item) {
        ids.push(item.c_task_id);
      });
      axios
        .post("calendar_task/delete", {
          ids: ids,
          company_id: company_data.company_id
        })
        .then(function(res) {
          _self.getTasks(parseParams(_self.pageData));
          _self.item.calendartask_count = res.data.task_count;
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    removeTaskAssign(id) {
      let _self = this;
      axios
        .post("calendar_task/remove_task_assign", {
          id: id
        })
        .then(function() {
          _self.getTaskAssignList(_self.assign_calendar_id);
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    taskStatusChangesList(unique_id) {
      this.unique_calendar_id = unique_id;
      this.task_all_status_list_popup = true;
    },
    taskNoteList(unique_id, task_name) {
      this.unique_calendar_id = unique_id;
      (this.task_name = task_name), (this.task_note_list_popup = true);
    },
    editTask(c_task_id, unique_id, status, item) {
      if (status == 1) {
        this.addCalendarTaskModal(c_task_id, unique_id);
      } else if (status == 5) {
        this.openDelayTaskPopup(item, "edit");
      } else if (status == 2) {
        this.scheduleTaskPopup(item, 2, "edit");
      } else if (status == 3) {
        this.scheduleTaskPopup(item, 3, "edit");
      }
    },
    addCalendarTaskModal(c_task_id, unique_id) {
      this.setAddTaskData({ key: "p_id", value: this.o_id });
      this.setAddTaskData({ key: "type_module", value: this.type });
      this.setAddTaskData({ key: "c_task_id", value: c_task_id });
      this.setAddTaskData({ key: "unique_id", value: unique_id });
      this.setAddTaskData({ key: "add_calendar_task_modal", value: true });
    },
    openDelayTaskPopup(item, is_add_edit) {
      let _self = this;
      _self.task_vendor = [];
      _self.task_customer = false;
      _self.task_user = [];
      _self.delay_task_id = item.c_task_id;
      _self.delay_task_popup = true;

      _self.previous_start_date = moment(item.start_date).format("MM/DD/YYYY");
      _self.previous_end_date = moment(item.end_date).format("MM/DD/YYYY");

      _self.delay_start_date = moment(item.start_date).format("MM/DD/YYYY");
      _self.delay_end_date = moment(item.end_date).format("MM/DD/YYYY");

      _self.dateFormattedDisplayStartDate1 = moment(item.start_date).format(
        "YYYY-MM-DD"
      );
      _self.dateFormattedDisplayEndDate1 = moment(item.end_date).format(
        "YYYY-MM-DD"
      );
      _self.task_customer = item.customer_count == 0 ? false : true;

      for (let key in item.vendor_task_assignment) {
        _self.task_vendor.push(item.vendor_task_assignment[key].user_type_id);
      }

      _self.previous_task_days = item.task_days;
      _self.previous_working_days = item.working_days;
      _self.is_add_edit = is_add_edit;
      if (is_add_edit == "edit") {
        _self.task_days = item.delay_days;
      }
    },

    delayTask(type) {
      this.form_error = {};
      let _self = this;
      let formData = new FormData();
      formData.append("o_id", _self.o_id);
      formData.append("c_task_id", this.delay_task_id);
      formData.append("task_note", this.delay_task_note);
      formData.append(
        "start_date",
        moment(this.delay_start_date).format("YYYY-MM-DD HH:mm:ss")
      );
      formData.append(
        "end_date",
        moment(this.delay_end_date).format("YYYY-MM-DD HH:mm:ss")
      );
      formData.append("task_days", parseInt(_self.task_days));
      formData.append("delay_days", parseInt(_self.task_days));
      formData.append("working_days", parseInt(_self.previous_working_days));
      formData.append("delay_reason", _self.delay_reason);
      formData.append("is_ext_delay", _self.is_ext_delay);
      formData.append("is_add_delay", _self.is_add_delay);
      formData.append("add_delay", _self.add_delay);
      formData.append("type", type);
      formData.append("task_vendor", _self.task_vendor);
      formData.append("task_customer", _self.task_customer);
      formData.append("task_user", parseInt(localStorage.getItem("user_id")));
      formData.append("is_add_edit", _self.is_add_edit);
      axios
        .post("calendar_task/delayTask", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.$set(_self.form_error, key, data.errors[key][0]);
            }
          } else {
            _self.delay_task_popup = false;
            _self.schedule_task_popup = false;
            _self.delay_task_id = "";
            _self.delay_task_note = "";
            _self.start_date = null;
            _self.end_date = null;
            _self.is_add_edit = "add";
            _self.task_vendor = [];
            _self.task_customer = false;
            _self.task_user = [];
            _self.task_days = 1;
            _self.add_days = 1;
            _self.getTasks(parseParams(_self.pageData));
          }
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
        });
    },
    completeTaskPopup(item) {
      let _self = this;
      _self.complete_task_popup = true;
      // _self.completion_date = moment(item.schedule_date).format("MM/DD/YYYY");

      _self.previous_start_date = moment(item.start_date).format("MM/DD/YYYY");
      _self.previous_end_date = moment(item.end_date).format("MM/DD/YYYY");
      _self.completion_date = moment(item.start_date).format("MM/DD/YYYY");
      _self.previous_task_days = item.working_days;
    },
    calculateCompletionDate() {
      let _self = this;
      const delay_start_date = _self.completion_date;
      const delay_end_date = _self.new_completion_date;

      // Split the date strings into components
      const [startMonth, startDay, startYear] = delay_start_date.split("/");
      const [endMonth, endDay, endYear] = delay_end_date.split("/");

      // Create Date objects
      const startDate = new Date(`${startMonth}/${startDay}/${startYear}`);
      const endDate = new Date(`${endMonth}/${endDay}/${endYear}`);

      // Calculate the difference in milliseconds
      const differenceInMs = endDate - startDate;

      // Convert milliseconds to days
      const millisecondsInOneDay = 1000 * 60 * 60 * 24;
      const differenceInDays = Math.floor(
        differenceInMs / millisecondsInOneDay
      );
      _self.completion_days = differenceInDays;
    },
    completeTask() {
      let _self = this;
      _self.calculateCompletionDate();
      let ids = [];
      _self.selectedRows2.map(function(item) {
        ids.push(item.c_task_id);
      });

      axios
        .post("calendar_task/completeTask", {
          ids: ids,
          start_date: moment(this.completion_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          completion_date: moment(this.new_completion_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          completion_days: this.completion_days,
          previous_task_days: this.previous_task_days,
          completion_note: this.completion_note
        })
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.$set(_self.form_error, key, data.errors[key][0]);
            }
          } else {
            _self.complete_task_popup = false;
            _self.completion_date = null;
            _self.new_completion_date = moment(new Date()).format("MM/DD/YYYY");
            _self.completion_days = 0;
            _self.completion_note = "";
            _self.getTasks(parseParams(_self.pageData));
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    scheduleTaskPopup(item, type, add_edit) {
      let _self = this;

      _self.task_vendor = [];
      _self.task_customer = false;
      _self.task_user = [];
      _self.delay_task_id = item.c_task_id;
      _self.schedule_task_popup = true;
      _self.schedule_lable = type;
      _self.previous_start_date = moment(item.start_date).format("MM/DD/YYYY");
      _self.previous_end_date = moment(item.end_date).format("MM/DD/YYYY");
      _self.previous_task_days = parseInt(item.working_days);
      _self.previous_working_days = parseInt(item.working_days);
      _self.task_customer = item.customer_count == 0 ? false : true;

      for (let key in item.vendor_task_assignment) {
        _self.task_vendor.push(item.vendor_task_assignment[key].user_type_id);
      }

      _self.is_add_edit = add_edit;
      if (add_edit == "edit") {
        _self.delay_task_note = item.task_note;
        _self.task_days = item.task_days;
      }

      _self.delay_start_date = moment(
        item.start_date,
        "YYYY-MM-DD HH:mm:ss"
      ).format("MM/DD/YYYY");
      _self.delay_end_date = moment(
        item.end_date,
        "YYYY-MM-DD HH:mm:ss"
      ).format("MM/DD/YYYY");
    },
    closeTaskNoteListPopup() {
      let _self = this;
      _self.task_note_list_popup = false;
    },
    updateVendorList() {
      const selectedItems = this.task_vendor.map(
        selectedValue =>
          this.vendor_list.find(vendor => vendor.value === selectedValue) || {
            value: selectedValue,
            text: selectedValue // Adjust this based on your data structure
          }
      );
      const remainingItems = this.vendor_list.filter(
        vendor => !this.task_vendor.includes(vendor.value)
      );

      this.setAddTaskData({
        key: "vendor_list",
        value: selectedItems.concat(remainingItems)
      });
    },

    getTaskAssignList(c_task_id) {
      let _self = this;
      _self.assign_calendar_id = c_task_id;
      axios
        .get("calendar_task/assign_list?unique_id=" + c_task_id)
        .then(response => {
          if (response.data.status) {
            let data = response.data.data;

            _self.assign_list = [];
            for (let key in data.customer_task_assignment) {
              _self.assign_list.push({
                user_type_id: data.customer_task_assignment[key].user_type_id,
                id: data.customer_task_assignment[key].id,
                name: data.customer_task_assignment[key].first_name
              });
            }
            for (let key in data.vendor_task_assignment) {
              _self.assign_list.push({
                user_type_id: data.vendor_task_assignment[key].user_type_id,
                id: data.vendor_task_assignment[key].id,
                name: data.vendor_task_assignment[key].v_name
              });
            }
            for (let key in data.user_task_assignment) {
              _self.assign_list.push({
                user_type_id: data.user_task_assignment[key].user_type_id,
                id: data.user_task_assignment[key].id,
                name: data.user_task_assignment[key].first_name
              });
            }
          }
        });
      _self.assign_list_popup = true;
    },
    // getVendors() {
    //   let _self = this;
    //   axios
    //     .get("get_vendors")
    //     .then(response => {
    //       if (response.data.status) {
    //         _self.vendor_list = response.data.data;
    //         this.setAddTaskData({
    //           key: "vendor_list",
    //           value: response.data.data
    //         });
    //       }
    //     })
    //     .catch(function() {});
    // },
    // getUsers() {
    //   let _self = this;
    //   axios
    //     .get("get_users")
    //     .then(response => {
    //       if (response.data.status) {
    //         _self.user_list = response.data.data;
    //         this.setAddTaskData({
    //           key: "user_list",
    //           value: response.data.data
    //         });
    //       }
    //     })
    //     .catch(function() {});
    // },
    getAllTask() {
      let _self = this;
      axios
        .get(
          "get_tasks_by_project?o_id=" +
            _self.o_id +
            "&type=" +
            _self.type +
            "&status=" +
            _self.pagination.filters.status +
            "&task=" +
            _self.pagination.filters.task
        )
        .then(response => {
          if (response.data.status) {
            _self.task_list = response.data.taskList;
            _self.status_list = response.data.statusList;
            _self.status_list.push({
              status: "All",
              task_status: "all"
            });

            this.setAddTaskData({
              key: "task_list",
              value: response.data.allTaskList
            });
          }
        })
        .catch(function() {});
    },
    filterTaskData() {
      this.getTasks(parseParams(this.pageData));
      this.getAllTask();
    },
    getProjectList() {
      let _self = this;

      axios
        .get("get_project_list_with_work_type?project_work_type=")
        .then(response => {
          if (response.data.status) {
            _self.setAddTaskData({
              key: "project_list",
              value: response.data.data.projects
            });
          }
        })
        .catch(function() {});
    }
  }
};
</script>
<style scope>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0px 5px !important;
}
.padding-5 {
  padding: 0px !important;
}
.footer-style {
  background-color: #f5f5f5;
  color: #333;
}
.p-0 {
  padding: 0px;
}
.custom-padding {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.top-padding {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.headline-1 {
  font-size: 17px !important;
}
</style>